import Vue, { CreateElement, VNode, VNodeChildren, VNodeData } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { NewRenterBlock, NewRenterBlockStep, ProfileMemoType, ProfileRulesBlock,
  TipsBlock } from '@/types';
import './memo.styl';
import { VIcon } from 'vuetify/lib';
import { Title, InfoBlock, AboutApartmentRuleItem } from '@/components';
import ProfileMemoRulesStep from './ProfileMemoRulesStep';

@Component({
  name: 'ProfileMemoRules',
})
export default class ProfileMemoRules extends Vue {
  @Prop({type: String, default: ''}) public readonly type!: ProfileMemoType;
  @Prop({type: Boolean, default: false}) public readonly isMobile!: boolean;
  @Prop({type: Object, default: () => {}}) public readonly newRenterBlock!: NewRenterBlock;
  @Prop({type: Object, default: () => {}}) public readonly tipsBlock!: TipsBlock;
  @Prop({type: Object, default: () => {}}) public readonly rulesBlock!: ProfileRulesBlock;

  public render(createElement: CreateElement): VNode {
    const data: VNodeData = {
      class: ['memo-container', this.isMobile && 'mobile'],
    };

    const title: VNode = createElement(Title, {
      props: {
        position: 'left',
        tag: 'h5',
        text: this.newRenterBlock?.title,
      },
    });

    const boockmark: VNode = createElement(VIcon, { class: 'bookmark'}, '$vuetify.icon.bookmark');

    const header: VNode = createElement('div', {class: 'memo-header'}, [title, boockmark]);

    const rent: VNode = createElement('div', { class: 'display-f memo-rent' }, [
      createElement('div', { class: 'display-f flex-3' },
        this.newRenterBlock?.steps?.map((step: NewRenterBlockStep) => {
          return createElement(ProfileMemoRulesStep, { props: { step }});
        }),
      ),
      createElement('div', { class: 'display-f flex-1'}, [
        createElement(InfoBlock, {
          props: {
            title: this.newRenterBlock?.questions?.title,
            phone: this.newRenterBlock?.questions?.phone,
            email: this.newRenterBlock?.questions?.email,
          },
        }),
      ]),
    ]);

    const mapIcon = {
      specialists: 'dialog',
      favours: 'parcel',
      storage: 'storage',
      news: 'dialog',
    };

    const mapedTips: object[] = ['specialists', 'favours', 'storage', 'news']
      .map((key: string) => {
        return {
          icon: mapIcon[key],
          text: this.tipsBlock && this.tipsBlock[key],
        };
      });

    const tips: VNodeChildren = [
      createElement(Title, { props: {
        tag: 'h6',
        text: this.tipsBlock?.title,
        position: 'left',
      }}),
      createElement('div', { class: 'tips-tile'},
        [
          mapedTips?.map((tip: any) => {
            return createElement('div', [
              createElement(VIcon, {
                  props: { size: 48 },
                  style: { width: '48px'},
                },
                `$vuetify.icon.${tip.icon}`),
              createElement('p', {class: 'p4'}, tip.text),
            ]);
          }),
        ],
      ),
    ];

    const rules: VNode = createElement('div', { class: 'memo-rule' }, [
      createElement(Title, { props: {
        tag: 'h6',
        position: 'left',
        text: this.rulesBlock?.title,
      }}),
      createElement('div', { class: 'rule-block'},
        [
          this.rulesBlock.items?.map((rule) => {
            return createElement(AboutApartmentRuleItem, { props: {
              name: rule.text,
              value: rule.bool,
            }});
          }),
        ],
      ),
    ]);

    const children: VNodeChildren = this.type === 'FULL' ? [
      header,
      rent,
      tips,
      rules,
    ] : [rules];

    return createElement('div', data, children);
  }
}
